import { Space } from 'antd'
import { useCreateProject } from 'app/components/Core/Project/hooks/useCreate'
import Empty from 'app/components/UI-Elements/Feedback/Empty'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import React from 'react'

export const ProjectEmptySearch = () => {
  const { tCore } = useTranslation({ scope: 'empty', recordType: RecordType.project })

  return (
    <>
      {tCore({
        id: 'empty_search_text'
      })}
    </>
  )
}

const ProjectEmpty: React.FC = () => {
  const { tCore } = useTranslation({ scope: 'empty', recordType: RecordType.project })
  const { onCreate: onCreateProject } = useCreateProject()

  return (
    <Empty
      description={
        <Space direction="vertical">
          <p>
            {tCore({
              id: 'description'
            })}
          </p>
          <Button
            onClick={onCreateProject}
            type="primary"
            title={tCore({ id: 'create_project' })}
          />
        </Space>
      }
    />
  )
}

export default ProjectEmpty
